import { dueState } from '@kanban/shared';
import { DUE_CHIP_CLASS, formatDueLabel } from '../lib/format.js';

/** Faelligkeits-Chip mit Farbcodierung nach SPEC 9.1. */
export function DueChip({
  dueAt,
  dueHasTime = false,
  completedAt,
}: {
  dueAt: string | null;
  dueHasTime?: boolean;
  completedAt: string | null;
}) {
  if (!dueAt) return null;
  const state = dueState(dueAt, completedAt);
  const label = formatDueLabel(dueAt, dueHasTime);
  const prefix = state === 'overdue' ? 'überfällig: ' : '';

  return (
    <span
      className={`inline-flex items-center rounded-[var(--radius-sm)] px-2 py-0.5 text-xs font-medium ${DUE_CHIP_CLASS[state]}`}
      title={`${prefix}${label}`}
    >
      {label}
    </span>
  );
}
